export enum FilterOperator {
  EQUALS = 'eq',
  STARTS_WITH = 'startswith',
  NOT_IN = 'nin',
  IN = 'in',
  NOT_CONTAINS = 'not contains',
  CONTAINS = 'contains',
  GREATER_THAN = 'gt',
  GREATER_THAN_OR_EQUALS = 'ge',
  LESS_THAN = 'lt',
  LESS_THAN_OR_EQUALS = 'le',
  IN_RANGE = 'range'
}
